export default __webpack_public_path__ + "static/media/bonus.6aa55687.svg";